import React, { PropsWithChildren, useContext } from 'react'
import { SecondaryPageBanner } from '../../../fragments/secondaryPageBanner'
import { GlobalContext } from '../../../globals/context'
import { isNotNull } from '../../../utils/nonNull'
import { SecondaryPageBannerFragment } from '@gql'

export type SecondaryBannerProps = {
  data: SecondaryPageBannerFragment
  breadcrumbs: React.ReactNode
}

export const ProductBanner: React.FC<PropsWithChildren<SecondaryBannerProps>> = ({ data, breadcrumbs }) => {
  const { fallback } = useContext(GlobalContext)

  if (!data || data.__typename !== 'secondaryPageBanner_BlockType' || fallback?.globalSet?.__typename !== 'siteSettings_GlobalSet') {
    return null
  }

  const { productListingImageFallback } = fallback.globalSet

  const { title, subTitle, primaryButton, secondaryButton, image, subBanner } = data

  const bannerImage = isNotNull(image) && image.length> 0 ? image: productListingImageFallback as typeof image

  type QuickLinkBlock = Extract<
    NonNullable<SecondaryPageBannerFragment['subBanner']>[number],
    { __typename: 'subBanner_quickLinks_BlockType' }
  >

  const filteredSubBanner = (subBanner?.filter(
    (item): item is QuickLinkBlock =>
      item?.__typename === 'subBanner_quickLinks_BlockType'
  ) ?? []) as SecondaryPageBannerFragment['subBanner']

  return (
    <SecondaryPageBanner
      title={title}
      subTitle={subTitle}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      image={bannerImage}
      breadcrumbs={breadcrumbs}
      subBanner={filteredSubBanner}
      after={'light'}
    />
  )
}
